import React, { useEffect } from 'react'
import Helmet from 'react-helmet'
import { useHistory } from 'react-router-dom'
import { useReceptionNo } from 'utils/commonHooks'
import { getGtag } from 'utils/gtag'
import DOMAIN from 'constants/domains'
import { getDomain , getKsGaId , getSaficGaId} from './utils/domain'

/** クライアント毎のGoogleAnalyticsの測定ID */
const GA_ID = getKsGaId() !== undefined ? getKsGaId() : getSaficGaId() !== undefined ? getSaficGaId() : 
  {
    [DOMAIN.SJ]: process.env.REACT_APP_QN_SJ_GA_ID,
  }[getDomain()] || ''

/**
 * Google Analyticsタグ
 * 着地したタイミングで受付番号が取得できない(=jwt取得できていない)ので、受付番号が取得できたときにGAを送信する
 */
const GATag: React.FC = () => {
  const history = useHistory()
  const receptionNo = useReceptionNo()

  // タブを閉じて復帰した場合は直接復帰画面の場合があるので、GA送信対象とする、それ以外の合は、jwtがない、リロード時にリロード前の画面が一瞬表示される理由からGA送信対象外とする

  useEffect(() => {
    /**
     * Routerのhistoryにスタックされたページパス/受付番号に更新がかかったときにGA送信を行う
     */

    /** GAタグのインスタンス */
    const gtag = getGtag()
    gtag('js', new Date())
    const postPagePath: () => void = () => {
      gtag('config', GA_ID)
      gtag('event', '受付番号_ページ参照', {
        ['viewer_reception_no']: receptionNo,
      })
    }

    receptionNo && postPagePath()
  }, [receptionNo, history.location.pathname])

  return (
    <Helmet>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
      />
    </Helmet>
  )
}

export default GATag
